import React from "react";
import "./phrase.css";

const phrases = [
  "La cosa más difícil es conocernos a nosotros mismos; la más fácil es hablar mal de los demás (Tales de Mileto)",
  "No puedo enseñar nada a nadie. Solo puedo hacerles pensar (Sócrates)",
  "No juzgamos a las personas que amamos (Jean-Paul Sartre)",
  "El conocimiento es poder (Francis Bacon)",
  "El amor inmaduro dice: “te amo porque te necesito”. El maduro dice: “te necesito porque te amo” (Erich Fromm)",
  "La peor lucha es la que no se hace (Karl Marx)",
  "No lastimes a los demás con lo que te causa dolor a ti mismo (Buda)",
  "Exígete mucho a ti mismo y espera poco de los demás. Así te ahorrarás disgustos (Confucio)",
  "El corazón tiene razones que la razón ignora (Blaise Pascal)",
  "Pocas veces pensamos en lo que tenemos; pero siempre en lo que nos falta (Schopenhauer)",
  "Nunca moriría por mis creencias porque podría estar equivocado (Bertrand Russell)",
  "Nuestra vida siempre expresa el resultado de nuestros pensamientos dominantes (Søren Kierkegaard)",
  "Todo el mundo ve lo que aparentas ser, pocos experimentan lo que realmente eres (Maquiavelo)",
  "Frecuentemente hay más que aprender de las preguntas inesperadas de un niño que de los discursos de un hombre (John Locke)",
  "El deseo es la verdadera esencia del hombre (Spinoza)",
  "No es lo que te ocurre, sino cómo reaccionas lo que importa (Epíteto)",
  "El secreto de la felicidad no es hacer siempre lo que se quiere, sino querer siempre lo que se hace (Tolstoi)",
  "La paciencia es amarga, pero su fruto es dulce (Jean-Jacques Rousseau)",
  "Nuestra envidia siempre dura más que la felicidad de quien envidiamos (Heráclito)",
  "La medida del amor es amar sin medida (San Agustín)",
  "Hace falta una vida para aprender a vivir (Séneca)",
  "Aquel que tiene un porqué para vivir se puede enfrentar a todos los 'cómos' (Friedrich Nietzsche)"
];

const Phrase = () => {
  const randomIndex = Math.floor(Math.random() * phrases.length);

  return (
    <>
      <div className="phrase_container">
        <div className="phrase">
          <p>{phrases[randomIndex]}</p>
        </div>
      </div>
    </>
  );
};

export default Phrase;
